import type { ReactNode } from 'react'
import { useRouter } from 'next/router'
import LoadingIcon from 'shared/icons/loading-icon'
import type { DomainAssetsInterface } from 'shared/types/domain'
import { baseServerSideProps } from 'shared/utils/base-server-side-props'
import { withDomainAssets } from 'shared/utils/with-domain-assets'
import { CommunityFeed } from 'modules/community/components/community-feed'
import CommunityLayout from 'modules/community/components/community-layout'
import { InvitationFlowGate } from 'modules/community/hooks/invitation-flow-gate'

function Community({ domainAssets }: { domainAssets?: DomainAssetsInterface }): ReactNode {
  const router = useRouter()
  const { invitationToken, showInvalidInvitation } = router.query

  if (!router.isReady) {
    return (
      <div className="flex justify-center p-10">
        <LoadingIcon />
      </div>
    )
  }

  if (Boolean(invitationToken) || Boolean(showInvalidInvitation)) {
    // TODO: rework how the invitation flow gates the community page.
    return <InvitationFlowGate />
  }

  return (
    <CommunityLayout domainAssets={domainAssets}>
      <CommunityFeed />
    </CommunityLayout>
  )
}

Community.getLayout = (page: ReactNode): ReactNode => page

export const getServerSideProps = withDomainAssets(baseServerSideProps)

export default Community
